/* Shared estimates only. Shopify is the authority for payable prices and discounts. */
(function (root) {
  const recipes = {beach:['backpack','brush'],tote:['original','mini'],big:['backpack','original','brush']};
  const regular = v => Math.max(v.price, v.compare_at_price || 0);
  function fullSizeBrushes(products) {
    const mini=value=>/\bmini\b/i.test(String(value||''));
    return products.filter(p=>!mini(p.title)&&!mini(p.handle)&&!mini(p.url))
      .map(p=>({...p,variants:p.variants.filter(v=>!mini(v.title))}))
      .filter(p=>p.variants.length);
  }
  function quote(variants, rate) {
    const retail = variants.reduce((n,v)=>n+regular(v),0);
    const selling = variants.reduce((n,v)=>n+v.price,0);
    const target = Math.round(retail * (100-rate)/100);
    return {retail, selling, total:Math.min(selling,target), saving:Math.max(0,retail-Math.min(selling,target)), extraSaving:Math.max(0,selling-target)};
  }
  function present(cart, families) {
    const result = {};
    for (const [slot,products] of Object.entries(families)) {
      const ids = new Set(products.map(p=>p.id));
      const item=cart.items.find(i=>{
        if(i.quantity<=0||i.selling_plan_allocation||!ids.has(i.product_id))return false;
        if(slot!=='brush')return true;
        const product=products.find(p=>p.id===i.product_id);
        return !product.variants||product.variants.some(v=>v.id===(i.variant_id??i.id));
      });
      if(item) result[slot]=item;
    }
    return result;
  }
  function completionQuote(cart, families, choices, recipe, rate) {
    const existing=present(cart,families);
    return quote(recipes[recipe].map(slot=>{
      const item=existing[slot];
      if(!item) return choices[slot].variant;
      return families[slot].flatMap(p=>p.variants).find(v=>v.id===item.variant_id||v.id===item.id)||{price:item.original_price??item.price};
    }),rate);
  }
  function completionOffer(cart, families, choices, rates) {
    const existing=present(cart,families);
    if(recipes.big.every(slot=>existing[slot])) return;
    const toteComplete=recipes.tote.every(slot=>existing[slot]);
    return Object.entries(recipes).map(([id,slots])=>({id,slots,missing:slots.filter(s=>!existing[s])}))
      .filter(r=>r.missing.length && r.missing.length<r.slots.length && r.missing.every(s=>choices[s]?.variant.available) && rates[r.id]>0)
      .filter(r=>!toteComplete || r.id==='big' && r.missing.length===1)
      .sort((a,b)=>a.missing.length-b.missing.length || rates[b.id]-rates[a.id] || b.slots.length-a.slots.length)[0];
  }
  const api={recipes,regular,quote,present,completionQuote,completionOffer,fullSizeBrushes};
  if(typeof module!=='undefined') module.exports=api;
  else root.SandeBundleEngine=api;
})(typeof window==='undefined'?{}:window);